interface PingProps {
  colour: string;
  size?: number;
  position: string;
  className?: string;
}

export default function Ping({ colour, size, position, className }: PingProps) {
  return (
    <span
      className={`absolute flex h-${size} w-${size} ${position} ${className}`}
    >
      <span
        className={`animate-ping absolute inline-flex h-full w-full rounded-full bg-${colour} opacity-75`}
      ></span>
      <span
        className={`relative inline-flex rounded-full h-${size} w-${size} bg-${colour}`}
      ></span>
    </span>
  );
}

Ping.defaultProps = {
  size: 3,
  className: "",
};
